var MIN_COUNT = 0;
var DEFAULT_COUNT = 5;
export function getCount(count) {
  if (!count || count < MIN_COUNT) {
    return DEFAULT_COUNT;
  }
  return count;
}